<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
	<g clip-path="url(#clip0_10110_2143)">
	<path d="M8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00001C14.6667 4.31811 11.6819 1.33334 8.00004 1.33334C4.31814 1.33334 1.33337 4.31811 1.33337 8.00001C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M5.33337 10H10.6667" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M10 6H10.0067" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	<path d="M6 6H6.00667" stroke="#5A5A5A" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<defs>
	<clipPath id="clip0_10110_2143">
	<rect width="16" height="16" fill="white"/>
	</clipPath>
	</defs>
	</svg>